<div class="row upload-buttons">
  <button class="btn btn-outline-primary" (click)="openExcelImport(excelImportModal)">Import Articles Excel File <img src="/assets/icons/excel-20.png"/></button>
  <button class="btn btn-outline-primary" (click)="openDxfImport(dxfImportModal)">Import DXF Files <img src="/assets/icons/dxf-20.png"/></button>
  <!-- <button class="btn btn-outline-primary" (click)="openExcelVarietyImport(excelVarietyImportModal)">Import Thermal Files</button> -->
  <button class="btn btn-outline-primary" (click)="downloadExcel()">Download Sample Excel File <img src="/assets/icons/excel-20.png"/></button>
</div>

<ng-template #excelImportModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload Excel File</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
	<app-excel-import (close)="modal.dismiss('Uploaded Excel file')"></app-excel-import>
</ng-template>

<ng-template #dxfImportModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload DXF File(s)</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
	<app-dxf-import (close)="modal.dismiss('Uploaded DXF file(s)')"></app-dxf-import>
</ng-template>

<ng-template #excelVarietyImportModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload Thermal Excel File</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <app-excel-variety-imports (close)="modal.dismiss('Uploaded Excel file')"></app-excel-variety-imports>
</ng-template>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>